import {
  FETCH_SALES_COMPETENCY_REVIEW,
  FETCH_SALES_COMPETENCY_REVIEW_SUCCESS,
  FETCH_SALES_COMPETENCY_REVIEW_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: true,
  currentReview: null,
  priorReview: null,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_SALES_COMPETENCY_REVIEW:
      return DEFAULT_STATE;
    break;
    case FETCH_SALES_COMPETENCY_REVIEW_SUCCESS:
      return {
        ...state,
        data: action.payload,
        currentReview: action.payload.current,
        priorReview: action.payload.prior,
        loading: false,
        error: null,
      }
    break;
    case FETCH_SALES_COMPETENCY_REVIEW_ERROR:
    console.log('FETCH_SALES_COMPETENCY_REVIEW_ERROR: ', action.payload);
      return {
        ...DEFAULT_STATE,
        loading: false,
        error: action.payload
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/viewingSalesCompetencyReviewReducer.js